<div
    class="info-handler icon-icon_questionmark_bck"
    [tcTooltip]="text"
    [placement]="textPlacement"
    [ngClass]="{ disabled: isDisabled }"
></div>
